import React from 'react';
import { Navbar } from './components/Navbar';
import { Hero } from './components/sections/Hero';
import { TrustBar } from './components/sections/TrustBar';
import { ValueProps } from './components/sections/ValueProps';
import { Services } from './components/sections/Services';
import { HowItWorks } from './components/sections/HowItWorks';
import { BuiltForRealtors } from './components/sections/BuiltForRealtors';
import { Testimonials } from './components/sections/Testimonials';
import { ServiceArea } from './components/sections/ServiceArea';
import { FinalCTA } from './components/sections/FinalCTA';
import { Footer } from './components/sections/Footer';
export function App() {
  return <div className="min-h-screen bg-white font-heading selection:bg-apex-green selection:text-white" data-id="element-0">
      <Navbar data-id="element-1" />
      <main data-id="element-2">
        <Hero data-id="element-3" />
        <TrustBar data-id="element-4" />
        <ValueProps data-id="element-5" />
        <Services data-id="element-6" />
        <HowItWorks data-id="element-7" />
        <BuiltForRealtors data-id="element-8" />
        <Testimonials data-id="element-9" />
        <ServiceArea data-id="element-10" />
        <FinalCTA data-id="element-11" />
      </main>
      <Footer data-id="element-12" />
    </div>;
}